import { render, staticRenderFns } from "./AdminModalReview.vue?vue&type=template&id=2bfc6379&"
import script from "./AdminModalReview.vue?vue&type=script&lang=js&"
export * from "./AdminModalReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports